import styled from "styled-components";

export const LessonContentContainer = styled.div`
  --topbar-height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: var(--topbar-height);

  .width-limiter {
    width: 100%;
    max-width: 1840px;
  }

  .ant-col.lesson-first-col:nth-child(1) {
    border-right: 2px solid ${({ theme }) => theme.colors.dividerColor};
    padding: 0 !important;
  }

  .ant-col.lesson-second-col:nth-child(2) {
    padding-top: 4rem !important;

    @media screen and (max-width: 1199px) {
      padding: 0 2rem 1.5rem 2rem !important;
    }
  }

  .ant-tabs-nav,
  .ant-tabs-tabpane.ant-tabs-tabpane-active {
    padding: 0 3rem;

    @media screen and (max-width: 1199px) {
      padding: 0 2rem;
    }
  }

  h2,
  p,
  span {
    color: ${({ theme }) => theme.colors.blogTextColorPrimary} !important;
  }

  .ant-btn span,
  svg {
    color: #ffffff !important;
  }

  .no-access-warn-container {
    display: flex;
    justify-content: center;
    padding: 1rem;
    margin-top: 2.5rem;

    .no-access-main-column {
      background: ${({ theme }) =>
        theme.mode === "dark"
          ? "#191919"
          : "rgb(255, 255, 255) none repeat scroll 0% 0%"};

      border-radius: 8px;
      height: 15rem;
      padding: 1rem;
      max-width: 87.5rem;
      width: 100%;

      @media screen and (min-width: 1200px) {
        height: 40rem;
        width: 100%;
      }
    }

    .no-access-warn-buy-option {
      display: grid;
      height: 100%;
      place-items: center;
      padding: 1rem;

      .prices-plus-info * {
        color: #f2f2f2 !important;
      }

      h5,
      .prices {
        text-align: center;
      }

      button {
        margin-top: 1rem;
      }

      div {
        max-width: 20rem;
      }
    }

    .no-access-warn-image {
      border-radius: 8px;
      height: 100%;
      position: relative;
      overflow: hidden;
    }

    img {
      position: absolute;
      filter: blur(15px);
      height: 15rem;
      object-fit: cover;
      width: 100%;
      transform: scale(1.05);

      @media screen and (min-width: 1200px) {
        width: 100%;
        height: 40rem;
      }
    }
  }
`;
